import React, {useState, useEffect} from 'react';
import { parseISO, format } from 'date-fns';
import Page from 'components/Templates/Page';
import api from 'services/api';
import { useHistory, Link } from "react-router-dom";
import BtnTitle from 'components/BtnTitle';

export default function Chapters() {
    const history = useHistory();
    const [chapters, setChapters] = useState([]);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const loadChapters = async () => {
            setIsLoading(true);
            try{
                const response = await api.get(`/admin/chapters`);
                setChapters(response.data);
                setIsLoading(false);
            }catch(error){
                setIsLoading(false);
            }
        }
        loadChapters();
    }, []);

    return (
        <Page name="chapters" loading={isLoading}>
            <h1>Capítulos
                <BtnTitle label="Adicionar" iconName="plus-circle" handleOnClick={()=> history.push('/chapters/add') } />
            </h1>

            <div className="container">
                <table className="uk-table uk-table-striped uk-table-small  uk-table-middle">
                <thead>
                    <tr>
                        <th width="200">Nome</th>
                        <th>Descrição</th>
                        <th>Audiobook</th>
                        <th width="130">Criado em:</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        chapters.map((chapter, index) => (
                            <tr key={index}>
                                <td><Link to={`/chapters/edit/${chapter._id}`}>{chapter.name}</Link></td>
                                <td>{chapter.description}</td>
                                <td>{chapter.audiobook.name}</td>
                                <td><i className='bx bx-calendar'></i>{format(parseISO(chapter.createdAt), 'dd/M/Y')}</td>
                            </tr>
                        ))
                    }
                </tbody>
                </table>

            </div>

            
       </Page>
    )
}
